import React, { useEffect, useState } from "react";
import RefinementList from "./refinementList";

import "~/css/accordion.css";

const Menu = (props) => {
  const [state, setState] = useState(false);

  useEffect(() => {
    setState(true);

    return () => {
      return false;
    };
  }, [state]);

  return (
    <div
      className="rounded-brand bg-white p-1 mt-4 xl:p-4 xl:w-1/4"
      style={{ boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.05)" }}
    >
      {state && (
        <RefinementList
          attribute="permalink.category"
          searchable={false}
          limit={50}
          limited={false}
        />
      )}
    </div>
  );
};

export default Menu;
